import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import EmotionalConnection from './components/EmotionalConnection';
import Services from './components/Services';
import SocialProof from './components/SocialProof';
import Differentiation from './components/Differentiation';
import Packages from './components/Packages';
import Urgency from './components/Urgency';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-black text-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/521161dc8188d5a0deb9a03b30fe0200/d584313f1887d86954b216b87d4f054b.png" 
              alt="PremierNY Logo" 
              className="h-12 w-auto"
            />
          </div>
          <div className="hidden md:flex items-center gap-10">
            <a href="#services" className="text-white/90 hover:text-[#D4AF37] transition-colors text-sm tracking-wide">Serviços</a>
            <a href="#testimonials" className="text-white/90 hover:text-[#D4AF37] transition-colors text-sm tracking-wide">Depoimentos</a>
            <a href="#packages" className="text-white/90 hover:text-[#D4AF37] transition-colors text-sm tracking-wide">Pacotes</a>
          </div>
          <a 
            href="https://wa.me/16466330270" 
            target="_blank" 
            rel="noopener noreferrer"
            className="px-6 py-3 border-2 border-[#D4AF37] text-white rounded-full hover:bg-[#D4AF37] hover:text-black transition-all duration-300 text-sm font-semibold whitespace-nowrap"
          >
            Fale Conosco
          </a>
        </div>
      </nav>

      <Hero />
      <EmotionalConnection />
      <Services />
      <Differentiation />
      <Packages />
      <Urgency />
      <FinalCTA />
      <SocialProof />
      <Footer />
    </div>
  );
}
